import { createReducer, on } from '@ngrx/store';
import * as OnboardingActions from './direct-onboarding.actions';
import { defaultOnboardingFilters, OnboardingManagementView } from './direct-onboarding.model';
import { initialOnboardingState, IOnboardingState } from './direct-onboarding.state';

export const onboardingReducer = createReducer(
  initialOnboardingState,

  // Load onboardings
  on(
    OnboardingActions.loadOnboardings,
    (state): IOnboardingState => ({
      ...state,
      isLoading: true,
      error: null as string | null,
    }),
  ),

  on(
    OnboardingActions.loadOnboardingsSuccess,
    (state, { onboardings, totalCount, currentPage }): IOnboardingState => ({
      ...state,
      onboardings,
      totalCount,
      currentPage,
      isLoading: false,
      error: null as string | null,
    }),
  ),

  on(OnboardingActions.loadOnboardingsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Filter actions
  on(OnboardingActions.setFilter, (state, { filter }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filter,
    },
  })),

  on(OnboardingActions.resetFilter, (state) => ({
    ...state,
    filters: { ...defaultOnboardingFilters },
    currentPage: 1,
  })),

  on(OnboardingActions.updateFilter, (state, { key, value }) => ({
    ...state,
    filters: {
      ...state.filters,
      [key]: value,
    },
    currentPage: 1, // Reset to first page when filter changes
  })),

  // Pagination actions
  on(OnboardingActions.updatePagination, (state, { page, pageSize }) => ({
    ...state,
    currentPage: page,
    filters: {
      ...state.filters,
      Page: page,
      PageSize: pageSize,
    },
  })),

  // Sorting actions
  on(OnboardingActions.setSorting, (state, { sortBy, sortDescending }) => ({
    ...state,
    filters: {
      ...state.filters,
      sortBy,
      sortDescending,
    },
  })),

  // Clear state
  on(
    OnboardingActions.clearOnboardings,
    (state): IOnboardingState => ({
      ...state,
      onboardings: [] as OnboardingManagementView[],
      totalCount: 0,
      currentPage: 1,
      error: null as string | null,
    }),
  ),
);
